(function () {
    // Add custom code below this line

    // Header menu
    const primaryNavItems = document.querySelectorAll('.header-navs li.primary-nav__item');

    primaryNavItems.forEach(item => {
        item.addEventListener('mouseenter', function () {
            this.classList.add('active-mega');
            this.closest('.header-navs').classList.add('active-overlay-mega');
        });

        item.addEventListener('mouseleave', function () {
            this.classList.remove('active-mega');
            this.closest('.header-navs').classList.remove('active-overlay-mega');
        });
    });

    // const menuActive = document.querySelector('.nav__sub__item--active');
    // menuActive.closest('.js-header-sub-link').classList.add("active_link");

    // Menu mobile
    document.querySelectorAll('.drawer__main-menu .sliderow__title').forEach(item => {
        item.addEventListener('click', function () {
            const drawerBody = this.closest('.drawer__body');
            if (drawerBody) {
                drawerBody.classList.add('has_dropdown');
            }
        });
    });

    document.querySelectorAll('.sliderow--back').forEach(item => {
        item.addEventListener('click', function () {
            const drawerBody = this.closest('.drawer__body');
            if (drawerBody) {
                drawerBody.classList.remove('has_dropdown');
            }
        });
    });

    document.querySelectorAll('.drawer .drawer__close').forEach(item => {
        item.addEventListener('click', function () {
            document.querySelectorAll('.drawer__body').forEach(body => {
                body.classList.remove('has_dropdown');
            });
        });
    });


})();
